import { render, staticRenderFns } from "./_bgaming.vue?vue&type=template&id=181699d8&lang=pug&"
import script from "./_bgaming.vue?vue&type=script&lang=js&"
export * from "./_bgaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports